/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Types of entities that can be referenced in activity feed messages.
 * Used for {EntityType:Guid} links in messages.
 * 
 * @export
 */
export const EntityTypeEnum = {
    RisqueAssure: 'RisqueAssure',
    Personne: 'Personne',
    BienImmobilier: 'BienImmobilier',
    Locataire: 'Locataire',
    Devis: 'Devis',
    Contrat: 'Contrat',
    Mandat: 'Mandat',
    Quittance: 'Quittance',
    Document: 'Document',
    Courtier: 'Courtier',
    Garantie: 'Garantie',
    Note: 'Note',
    DemandeValidation: 'DemandeValidation'
} as const;
export type EntityTypeEnum = typeof EntityTypeEnum[keyof typeof EntityTypeEnum];


export function instanceOfEntityTypeEnum(value: any): boolean {
    for (const key in EntityTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(EntityTypeEnum, key)) {
            if (EntityTypeEnum[key as keyof typeof EntityTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EntityTypeEnumFromJSON(json: any): EntityTypeEnum {
    return EntityTypeEnumFromJSONTyped(json, false);
}

export function EntityTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityTypeEnum {
    return json as EntityTypeEnum;
}

export function EntityTypeEnumToJSON(value?: EntityTypeEnum | null): any {
    return value as any;
}

export function EntityTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): EntityTypeEnum {
    return value as EntityTypeEnum;
}

